import { render, staticRenderFns } from "./tggd.vue?vue&type=template&id=34c68c84&scoped=true"
import script from "./tggd.vue?vue&type=script&lang=js"
export * from "./tggd.vue?vue&type=script&lang=js"
import style0 from "./tggd.vue?vue&type=style&index=0&id=34c68c84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c68c84",
  null
  
)

export default component.exports